import $ from "jquery"
import select2 from "select2"

$(function () {
	$('select.select2').select2({
		theme: 'bootstrap-5',
		width: 'style'
	});

	const $posts = $('.posts.programs');
	if (!$posts.hasClass('explaining')) {
		const $postItems = $posts.find('.postItems');
		$postItems.trigger('postLoadAjax');
	}

});
